import { useNavigate } from "react-router-dom";
import { MotifButton } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import {
  havingAddPermission,
  havingDeletePermission,
  havingEditPermission,
} from "@/utility/common";
import {
  GetCommonDeleteImgButton,
  GetCommonDownArrowImgButton,
  GetCommonUpArrowImgButton,
} from "@/components/Images/CommonImages";

export const useCustomCellRenderers = ({
  setShowEditClassPopup,
  setEditClassData,
  setShowDeleteClassPopup,
  handleShiftRow,
  classPermissions,
}: {
  setShowEditClassPopup: (value: boolean) => void;
  setEditClassData: (data: any) => void;
  setShowDeleteClassPopup: (value: boolean) => void;
  handleShiftRow: (rowIndex: number, direction: "up" | "down") => void;
  classPermissions: string[];
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const caseRenderers = {
    nameCellRenderers: function (param: any) {
      return (
        <div
          style={
            havingEditPermission(classPermissions)
              ? { cursor: "pointer" }
              : { cursor: "default" }
          }
          onClick={() => {
            if (havingEditPermission(classPermissions)) {
              const { ruleCount, ...remainingData } = param.data;
              setEditClassData(remainingData);
              setShowEditClassPopup(true);
            }
          }}
        >
          {param.data.name}
        </div>
      );
    },
    ruleLinkCellRenderers: function (param: any) {
      return havingAddPermission(classPermissions) ? (
        <MotifButton
          onClick={() => {
            const { ruleCount, ...classData } = param.data;
            navigate(`./create-rule`, {
              state: { classData },
            });
          }}
          size="small"
          type="button"
          variant="text-alt"
        >
          {t("pages.configuration.scheme.formLabels.addNewRule")}
        </MotifButton>
      ) : (
        <></>
      );
    },
    actionCellRenderers: function (param: any) {
      return (
        <div className="motif-row">
          {
            havingDeletePermission(classPermissions) && (
              <GetCommonDeleteImgButton
                onClick={() => {
                  const { ruleCount, ...remainingData } = param.data;
                  setEditClassData(remainingData);
                  setShowDeleteClassPopup(true);
                }}
              ></GetCommonDeleteImgButton>
            )
            // <div className="motif-col-lg-6">
            // 	<CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
            // 	<MotifButton
            // 		size="small"
            // 		variant={DELETE_IMG_VARIANT}
            // 		type="button"
            // 		onClick={() => {
            // 			const { ruleCount, ...remainingData } = param.data;
            // 			setEditClassData(remainingData);
            // 			setShowDeleteClassPopup(true);
            // 		}}
            // 	>
            // 		{getCommonDeleteImg()}
            // 	</MotifButton>
            // 	</CommonTooltipWrapper>
            // </div>
          }
          {/* <div className="motif-col-lg-6">
						<MotifButton
							onClick={() => {
								const { ruleCount, ...remainingData } = param.data;
								setEditClassData(remainingData);
								setShowEditClassPopup(true);
							}}
							size="small"
							type="button"
							variant="primary"
						>
							<MotifIcon
								iconFunction={IconoirEditPencil}
								stroke="blue"
								strokeWidth="2"
								size="24"
							/>
						</MotifButton>
					</div> */}
        </div>
      );
    },
    sortingCellRenderers: function (param: any) {
      const { isDraft } = param;
      return havingEditPermission(classPermissions) ? (
        <>
          <GetCommonUpArrowImgButton
            disabled={!isDraft}
            onClick={() => handleShiftRow(param.rowIndex, "up")}
          ></GetCommonUpArrowImgButton>
          <GetCommonDownArrowImgButton
            onClick={() => handleShiftRow(param.rowIndex, "down")}
            disabled={!isDraft}
          ></GetCommonDownArrowImgButton>
        </>
      ) : (
        <></>
      );
    },
  };
  return caseRenderers;
};
